module.exports = __webpack_public_path__ + "img/deleteProject.fdf23a61.svg";